export const CHAT_BOT_STATE_UPDATE = 'CHAT/BOT_STATE/UPDATE'
